import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
// import { StyledApplication } from './styles';
import localStorage from '../../../../utils/localStorage';
// import StyledTable from '../../../commons/styles/table';
import { Tabs, Form, Button, Select, Tooltip, message, Table, InputNumber,Divider, Col, Row, Space, Input ,Switch,Popconfirm} from 'antd';
import { EditOutlined ,QuestionCircleOutlined,DeleteOutlined,PlusOutlined} from '@ant-design/icons';
import {
  // API_DEVICE,
  // API_PARAMETER,
  DATA_ALERT_RULES,
  // API_DEVICETYPE,
  // API_DOWNLOAD,
  // IPAddress,
  // API_RUBUSMASTERS
} from '../../../../commons/api';
import { recipientListAPI, deviceListApi,updateRuleStatus } from './apiCalls';
const { Option } = Select;
const { TabPane } = Tabs;

const DataAlerts = ({ translationCache }) => {
  // const [disableDetails, setDisableDetails] = useState(true);
  // const [disabledDropdown, setDisabledDropdown] = useState(false);
  const [recipientList, setRecipientList] = useState([]);
  const [datasource, setDatasource] = useState([]);
  const [formObject, setFormObject] = useState({});
  const [activeKey, setActiveKey] = useState('List');
  const [deviceList, setDeviceList] = useState([]);
  const [name, setName] = useState('');
  const inputRef = useRef(null);
  const hRef = useRef();

  useEffect(() => {
    getMasterList();
    mailData();
    DeviceTypeApi();
    // AssetTypeApi();
  }, []);


  const mailData = async () => {
    let recipientData = await recipientListAPI();
    setRecipientList(recipientData?.data || []);
  };

  const DeviceTypeApi = async () => {
    let deviceData = await deviceListApi();
    setDeviceList(deviceData?.data || []);
  };

  // const AssetTypeApi = () => {
  //   const siteId = localStorage.get('currentSite');
  //   const accessToken = localStorage.get('accessToken');
  //   const type = {
  //     method: 'GET',
  //     url: `${API_RUBUSMASTERS.AssetTypesGET}?SiteId=${siteId}`,
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`
  //     }
  //   };
  //   axios(type)
  //     .then((response) => {
  //       setAssetTypeList(response.data);
  //     })
  //     .catch(() => {});
  // };


  const submitApi = async (values, url) => {
    const siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
    let Authorization = 'Bearer ' + token;
    const getRootCauseInfo = {
      method: 'POST',
      url: `${url}?SiteId=${siteId}`,
      headers: {
        Authorization: Authorization
      },
      data: values
    };
    return axios(getRootCauseInfo)
      .then((response) => {
        if (response && response.data && response.data.message) {
          message.success(response.data.message);
          getMasterList();
          setActiveKey('List');
        }
      })
      .catch((err) => {
        if (err.response.status === 400 || err.response.status === 500) {
          message.info(err.response.data.message);
        }
      });
  };
  const update = async (values, url,Id) => {
    const siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
    let Authorization = 'Bearer ' + token;
    const getRootCauseInfo = {
      method: 'Patch',
      url: `${url}?SiteId=${siteId}&Id=${Id}`,
      headers: {
        Authorization: Authorization
      },
      data: values
    };
    return axios(getRootCauseInfo)
      .then((response) => {
        if (response && response.data && response.data.message) {
          message.success(response.data.message);
          getMasterList();
          setActiveKey('List');
        }
      })
      .catch((err) => {
        if (err.response.status === 400 || err.response.status === 500) {
          message.info(err.response.data.message);
        }
      });
  };

  const getMasterList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const Object = {
      method: 'GET',
      url: `${DATA_ALERT_RULES.GET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(Object)
      .then((response) => {
        setDatasource(response.data);
      })
      .catch(() => { });
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };


  const onFinish = async () => {
    let saveObject = {};
    hRef.current && hRef.current.validateFields().then(async (values) => {
      if (formObject && formObject.Id) {
        saveObject = {
          Name: values.name,
          Description: values.description,
          DeviceType: values.deviceType,
          Frequency: values.frequency,
          MailIds: values.mailList,
        };
        await update(saveObject, DATA_ALERT_RULES.Update, values.Id);
        getMasterList();
        setActiveKey('List');
        hRef.current &&
          hRef.current.setFieldsValue({
            name: null,
            description: null,
            deviceType: null,
            frequency: null,
            mailList: null,
          });
      } else {
        saveObject = {
          Name: values.name,
          Description: values.description,
          DeviceType: values.deviceType,
          Frequency: values.frequency,
          MailIds: values.mailList
        };
        await submitApi(saveObject, DATA_ALERT_RULES.Create);
        getMasterList();
        setActiveKey('List');
        hRef.current &&
          hRef.current.setFieldsValue({
            name: null,
            description: null,
            deviceType: null,
            frequency: 15,
            mailList: null,
          });
        setFormObject({});
      }
    });
  };

  const onClose =()=>{
    hRef.current && hRef.current.setFieldsValue({
      name:null,
      description:null,
      deviceType: null,
      frequency: null,
      mailList: null
    });
    setActiveKey({activeKey:'List'});
    setFormObject({});
  };


  const TabChange = (activeKey) => {
    if (activeKey === 'Details') {
      hRef.current && hRef.current.setFieldsValue({
        name:null,
        description:null,
        deviceType: null,
        frequency: 15,
        mailList: null
      });
      setActiveKey(activeKey);
    } else if (activeKey === 'List') {
      hRef.current && hRef.current.setFieldsValue({
        name:null,
        description:null,
        deviceType: null,
        frequency: null,
        mailList: null
      });
      setActiveKey(activeKey);
      setFormObject({});
    }
  };

  const ruleStatusUpdate = async (rule) => {
    const payLoad = {
      Id: rule?.Id,
      RuleStatus: !rule.RuleStatus,
    };
    const data = await updateRuleStatus(payLoad);
    if (data && data.status === 200) {
      const data = await getMasterList();
      setDatasource(data);
    } else {
      message.error('something Went Wrong');
    }
  };

  const columns = [
    {
      title: translation('DeviceType'),
      dataIndex: 'DeviceType',
      key: 'DeviceType'
    },
    {
      title: translation('Name'),
      dataIndex: 'Name',
      key: 'Name'
    },
    {
      title: translation('Frequency'),
      dataIndex: 'Frequency',
      key: 'Frequency'
    },
    {
      title: translation('Description'),
      dataIndex: 'Description',
      key: 'Description'
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      key: 'Status'
    },
    {
      title: translation("RuleStatus"),
      key: 'RuleStatus',
      render: (text, record, index) => (
        <span>
          <Switch
            checkedChildren={'Active'}
            unCheckedChildren={'InActive' }
            checked={record.RuleStatus}
            onChange={() => {
              ruleStatusUpdate(record, index);
            }}
            style={{
              backgroundColor: record.RuleStatus ? '#416a41' : '#9f3f47',
            }}
          />
        </span>
      )
    },
    {
      title: translation('Action'),
      dataIndex: 'Action',
      key: 'Action',
      render: (text, record) => (
        <>
          <Tooltip placement="top" title={translation('edit')}>
            <Button type='primary' className="ant-btn" onClick={() => _editRecord(record)} >
              <EditOutlined />
            </Button>
          </Tooltip>
          <Popconfirm
            title={translation("Are You Sure That YouWant To Delete")}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => deleteRecord(record.Id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type='primary' style={{ marginLeft: '8px' }}>
              <Tooltip title={translation('Delete')}>
                <DeleteOutlined />
              </Tooltip>
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  const _editRecord = (record) => {
    if (hRef.current) {
      hRef.current.setFieldsValue({
        name:record.Name,
        description:record.Description,
        deviceType: record.DeviceType,
        frequency: record.Frequency,
        mailList: record.MailIds,
        Id:record.Id
      });
    }
    setFormObject({
      name:record.Name,
      description:record.Description,
      deviceType: record.DeviceType,
      frequency: record.Frequency,
      mailList: record.MailIds,
      Id:record.Id
    });
    setActiveKey('Details');
  };

  const deleteRecord = (Id)=>{
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const Object = {
      method: 'delete',
      url: `${DATA_ALERT_RULES.Delete}?SiteId=${siteId}&Id=${Id}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(Object)
      .then((response) => {
        message.success(response.data.message);
        return response.data;
      })
      .catch((err) => {
        message.error(err.response.data.message);
      });
      getMasterList();
  };

  const onChangeMin = (value) => {
   let formObjectData = hRef.current && hRef.current.getFieldsValue();
  setFormObject({
    ...formObjectData,
    Id:formObject.Id,
    frequency: value
  });
  };

  const onNameChange = event => {
    setName(event.target.value);
  };
  
  const addItem = e => {
    e.preventDefault();
    // Avoid adding empty or duplicate emails
    if (!name || recipientList.some(item => item.Email === name)) return;
    setRecipientList([...recipientList, { Email: name }]);
    setName('');
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  return (
    <div>
      <Tabs
        type="card"
        defaultActiveKey="List"
        activeKey={activeKey}
        onChange={TabChange}
      >
        <TabPane tab={translation('List')} key="List">
          <Table size="small" columns={columns} dataSource={datasource} />
        </TabPane>

        <TabPane tab={translation('Details')} key="Details">
          {/* <Tabs
            tabPosition="left"
            defaultActiveKey="1"
            activeKey={activeDetails}
            onChange={(activeDetails) => {
              if (activeDetails === '2') {
                hRef.current && hRef.current.setFieldsValue({
                  deviceType: null,
                  DeviceCode: null,
                  Parameter: []
                });
                setActiveDetails(activeDetails);
              }
              if (activeDetails === '1') {
                setActiveDetails(activeDetails);
              }
            }}
          > */}
          <div style={{ marginTop: '25px' }}>
            <Form
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 12 }}
              layout="vertical"
              ref={hRef}
              name="Site_form"
              initialValues={formObject}
              onFinish={onFinish}
              autoComplete="off"
            >
              <Row gutter={18}>
              <Form.Item name="Id"></Form.Item>
                <Col span={10}>
                  <Form.Item
                    label={translation('Name')}
                    name="name"
                    rules={[{ required: true, message: translation('Please select Name !') }]}
                  >
                    <Input value={formObject.name} placeholder={translation('Please enter Name')} />
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item
                    label={translation('Description')}
                    name="description"
                    rules={[{ required: true, message: translation('Please select Description !') }]}
                  >
                    <Input value={formObject.description} placeholder={translation('Please enter Description')} />
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item
                    label={translation('Device Type')}
                    name="deviceType"
                    rules={[{ required: true, message: translation('Please select DeviceType !') }]}
                  >
                    <Select>
                      {deviceList &&
                        Array.isArray(deviceList) &&
                        deviceList.map((item, index) => (
                          <Option key={index} value={item.AliasCode}>
                            {item.AliasCode}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item
                    label={translation('Frequency')}
                    name="frequency"
                    rules={[{ required: true, message: translation('Please select Frequency !') }]}
                  >
                    <InputNumber min={5} max={60} defaultValue={15} 
                     formatter={value => `${value}`}
                     onChange={onChangeMin} />
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item
                    label={translation('Mail')}
                    name="mailList"
                    rules={[{ required: true, message: translation('Please select Mail !') }]}
                  >
                    <Select
                      mode="multiple"
                      style={{ width: 300 }}
                      placeholder={translation('RecipientList')}
                      popupRender={menu => (
                        <>
                          {menu}
                          <Divider style={{ margin: '8px 0' }} />
                          <Space style={{ padding: '0 8px 4px' }}>
                            <Input
                              placeholder="Please enter item"
                              ref={inputRef}
                              value={name}
                              onChange={onNameChange}
                              onKeyDown={e => e.stopPropagation()}
                            />
                            <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
                              Add item
                            </Button>
                          </Space>
                        </>
                      )}
                    >
                       {recipientList &&
                        Array.isArray(recipientList) &&
                        recipientList.map((item) => (
                          <Option key={item.Email} value={item.Email}>
                            {item.Email}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item>
                <Space>
                  {formObject && formObject.Id ?
                    <Button type="primary" htmlType="submit">
                      {translation('Update')}
                    </Button>
                    :
                    <Button type="primary" htmlType="submit">
                      {translation('Save')}
                    </Button>}
                  <Button type="primary" onClick={onClose}>
                    {translation('Cancel')}
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </div>
          {/* </Tabs> */}
        </TabPane>
      </Tabs>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache
  };
};

export default connect(mapStateToProps)(DataAlerts);